'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentId$$anon$1() {
}
export { $c_Lapp_data_AppDocumentId$$anon$1 as $c_Lapp_data_AppDocumentId$$anon$1 };
$p = $c_Lapp_data_AppDocumentId$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentId$$anon$1;
/** @constructor */
function $h_Lapp_data_AppDocumentId$$anon$1() {
}
export { $h_Lapp_data_AppDocumentId$$anon$1 as $h_Lapp_data_AppDocumentId$$anon$1 };
$h_Lapp_data_AppDocumentId$$anon$1.prototype = $p;
$p.aT = (function(t) {
  return t.ue();
});
var $d_Lapp_data_AppDocumentId$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentId$$anon$1, "app.data.AppDocumentId$$anon$1", ({
  C4: 1,
  a: 1,
  aO: 1,
  aN: 1
}));
export { $d_Lapp_data_AppDocumentId$$anon$1 as $d_Lapp_data_AppDocumentId$$anon$1 };
//# sourceMappingURL=app.data.-App-Document-Id$$anon$1.js.map
